import { Autocomplete, Box, Stack, TextField, Typography } from "@mui/material";
import { Component } from "react";
import { httpGet } from "../util/http";
//import { httpGet, httpPost } from "../util/http";

export default class TipoMetaSelect extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [
                { tipo: 1, nome: 'Diferença de Inventário' },//monetario
                { tipo: 2, nome: 'Itens Ajustados' },//inteiro
                { tipo: 3, nome: 'Estoque Avaria' },//inteiro
                { tipo: 4, nome: 'Percentual Romaneio' },//percentual
                { tipo: 5, nome: 'Contagem Semanal' },//inteiro
                { tipo: 6, nome: 'Tempo de Contagem' },//horas
            ],
            loading: false,
        }
    }

    render() {
        return (
            <Autocomplete {...this.props.props}
                disabled={this.props.disabled}
                noOptionsText="Nenhum tipo"
                loadingText="Carregando..."
                openText="Abrir lista"
                value={this.props.value} options={this.state.items}
                size="small"
                sx={{
                    ...this.props.sx,
                }}
                isOptionEqualToValue={(option, value) => option.tipo === value.tipo}
                getOptionLabel={option => option.nome}
                onChange={(e, value) => this.props.onChange ? this.props.onChange(value) : {}}
                renderInput={(params) => <TextField
                    {...params}
                    error={this.props.error === true}
                    helperText={this.props.error === true ? "Informe o tipo" : null}
                    label={'Tipo' + (this.props.required ? '*' : '')} />}
            />
        );
    }
}